/**
 * 缓存的接口
 * 配置类不经常变动的接口
 */

import { fetchGetHotelChannelList } from './channel';
import CheckInBaseService from './checkInBase';
import { fetchRoomTypeList } from './roomManagement';
import { getMarketingConfig } from './wechatMoment';
import { getEmployeeJobList } from './employeeManage';
import { fetchRoomsList } from './goodsStock';
import { getCardSellConfig, fetchAllMemberLevelList } from './guest';
import {
  getTenantBaseConfig,
  getUserBaseConfig,
  fetchEmployeeCurrent,
  getTenantSysConfig,
  getLoginMethodList,
} from './login';
import { getCurrentStoreDetail } from './shopProfile';

/**
 * @param requestFunc 请求方法
 */
const createCacheRequest = (requestFunc) => {
  let cacheRequest: Promise<any>;
  let cacheRequestKey;
  return (requestKey?) => {
    // 请求key
    if (requestKey !== cacheRequestKey) {
      cacheRequest = null;
    }
    cacheRequestKey = requestKey;
    if (!cacheRequest) {
      cacheRequest = requestFunc().then(
        (res) => {
          return res;
        },
        (err) => {
          // 请求出错
          cacheRequest = null;
          throw err;
        },
      );
    }
    return cacheRequest;
  };
};

// 获取所有渠道列表
export const getAllChannelWithCache = createCacheRequest(fetchGetHotelChannelList);

// 线下预订、入住可用渠道
export const getReserveChannelWithCache = createCacheRequest(CheckInBaseService.getChannelList);

// 获取门店房型列表
export const getRoomTypeListWithCache = createCacheRequest(fetchRoomTypeList);

// 获取门店微信营销
export const getMarketingConfigWithCache = createCacheRequest(getMarketingConfig);

// ehr 岗位列表
export const getEmployeeJobListWithCache = createCacheRequest(getEmployeeJobList);

// 获取房间列表
export const getRoomListWithCache = createCacheRequest(fetchRoomsList);
// 会员卡
export const getMemberCardListWithCache = createCacheRequest(getCardSellConfig);

// 租户配置信息
export const getTenantConfigWithCache = createCacheRequest(getTenantBaseConfig);

// 获取用户配置信息
export const getUserConfigWithCache = createCacheRequest(getUserBaseConfig);

export const getTenantSysConfigWithCache = createCacheRequest(getTenantSysConfig);

// 获取用户信息
export const getUserInfoWithCache = createCacheRequest(fetchEmployeeCurrent);

// 获取登录方式
export const getLoginMethodListWithCache = createCacheRequest(getLoginMethodList);

// 获取当前门店信息
export const getStoreDetailWithCache = createCacheRequest(getCurrentStoreDetail);

// 获取会员等级配置
export const getMemberLevelListWithCache = createCacheRequest(fetchAllMemberLevelList);
